<template>
  <div :class="{
    aro_interation_normal: $aroConfig.mode == 0, 
    aro_interation_hidden: $aroConfig.mode == 1}">  
    <router-view ref="AroView"/>  
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import * as common from '@/utils/common';

export default {
  name: 'App',
  computed: {
    ...mapState("app", ["loginInfo"]),
    loginInfo: {
      get() {return this.$store.state.app.loginInfo;},
      set(val) {this.setLoginInfo = val;}
    }
  },
  created() {
    let _this = this;
     //Aro Login Info
    _this.loginInfo = _this.$aroConfig.loginInfo;
  },
  mounted() {
    let _this = this;

    //Aro UI 
    _this.$aroUiInitialize.call();
  }  
}
</script>
<style>
.aro_interation_normal{
  min-height: 800px;
}

.aro_interation_hidden{
  height: 0px;
  width: 0px;
  min-height: 0px;
  /*display: none;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue